<template>
  <div class="herdes">
    <div class="herde-center">
      <img class="blueArhive" src="../assets/images/bluearhive.png" alt/>
      <ul>
        <li
            v-for="(list, index) in siYuan"
            class="title"
            :class="{ red: changeRed == index }"
            @click="change(index, list.router)"
            :key="index"
        >
          {{ list.a }}
        </li>
      </ul>
      <a href="https://www.youtube.com/watch?v=0KFPtliRn_4" target="_Blank">
        <img class="yt_logo" src="../assets/images/yt_logo.png" alt/>
      </a>
      <a href="https://twitter.com/Blue_ArchiveJP" target="_Blank">
        <img class="tw_logo" src="../assets/images/tw.png" alt="twitter" title="Twitter"/>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'herde',
  props: ['isBosyuu'],
  components: {},
  data: () => ({
    changeRed: 0,
  }),
  computed: {
    siYuan() {
      console.log();
      if (this.$route.path.indexOf('/bosyuu') == -1 && this.$route.path.indexOf('/serial_code') == -1) {
        return [
          {a: 'HOME', router: '/'},
          // { a: "NEWS", router: "/news" },
          {a: 'NEWS', router: '/news/newsJump'},
          {a: 'CHARACTER', router: '/character'},
          {a: 'SYSTEM', router: '/system'},
          {a: 'FANKIT', router: '/fankit'},
          {a: 'FAQ', router: '/faq'},
          {a: 'CONTACT', router: '/contact-1-hint'},
        ]
      } else {
        return []
      }
    },
  },
  created() {
  },
  mounted() {
    for (let i in this.siYuan) {
      // this.$route.path
      // this.siYuan[i].router
      if (this.$route.path.indexOf('/comics') != -1) {
        this.changeRed = -1
      } else if (this.$route.path.indexOf(this.siYuan[i].router) > -1) {
        this.changeRed = i
      }
    }

  },
  watch: {},
  methods: {
    change(index, path) {
      this.changeRed = index
      this.$router.push(path)
    },
  },
}
</script>

<style lang="scss" scoped>
.herdes {
  z-index: 999;
  position: absolute;
  top: 0;
  height: pxTorem(68px);
  width: 100%;
  background: rgba(20, 39, 59, 0.8);
  background-size: 100% 100%;
  box-shadow: 0 pxTorem(2px) pxTorem(10px) pxTorem(5px) rgba(20, 39, 59, 0.6);

  .herde-center {
    position: relative;
    display: flex;

    .blueArhive {
      margin-top: pxTorem(3px);
      margin-left: pxTorem(108px);
      width: pxTorem(157px);
      height: pxTorem(56px);
    }

    // a {
    //   display: block;
    //   position: absolute;
    //   width: pxTorem(96px);
    //   top: pxTorem(24px);
    //   right: pxTorem(124px);
    //   background: url(../assets/images/yt_logo.png);
    //   background-size: 100%;
    // }
    .yt_logo {
      position: absolute;
      width: pxTorem(96px);
      top: pxTorem(24px);
      right: pxTorem(124px);
      cursor: pointer;
    }

    .tw_logo {
      position: absolute;
      width: pxTorem(30px);
      right: pxTorem(52px);
      top: pxTorem(19px);
      cursor: pointer;
    }

    ul {
      display: flex;
      margin-left: pxTorem(150px);
      flex: 0 0 65%;

      .title {
        box-sizing: border-box;
        padding: 0 pxTorem(32px);
        cursor: pointer;
        color: white;
        font-size: pxTorem(16px);
        line-height: pxTorem(68px);
        // font-weight: 900;
        // margin-right: pxTorem(54px);

        font-family: "Noto Sans JP", sans-serif;
        font-weight: 400;
        letter-spacing: pxTorem(3px);
      }

      .red {
        background: url(../assets/images/blue-l.png) no-repeat;
        background-size: 100%;
      }
    }
  }
}
</style>
